module.exports = __webpack_public_path__ + "img/3739848243be7af2d6aa32914171fbb3.png";